import r from "../managers/braze-instance.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import ee, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function disableSDK() {
  var e = r.nn();
  e && e.requestImmediateDataFlush();
  var n = new ee.ne(null, !0),
    a = "This-cookie-will-expire-in-" + n.se();
  n.store(s.ie, a);
  var i = et.Us.Rs;
  new et(i, E).setItem(i.Fs.le, i.me, !0), E.info("disableSDK was called"), r.destroy(!1), r.ce(!0);
}